import React, { Component } from 'react';
import Option from './Option';
import ErrorMessage from './ErrorMessage';
import '../../assets/styles/Converter/Select.sass';

class Select extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.magnitude !== this.props.magnitude) {
      this.dispatchSelectedOption({});
    }
  }

  buildOptions() {
    return this.props.magnitude.systems.map(system => {
      let units = system.units;

      let options = units.map((unit, index) => {
        let selected = index === 0 ? 'selected' : '';
        return <Option unit={unit} key={unit.id} selected={selected} />;
      });

      return <optgroup label={system.name} key={system.id}>{options}</optgroup>
    });
  }

  dispatchSelectedOption() {
    let name = this.props.name;
    let option = this.refs.select.selectedOptions[0];

    if (!option) return;

    let [unitName, unitFactor] = [option.value, option.dataset.factor];
    let data = { [name]: { unit: unitName, factor: unitFactor } };

    this.props.setSelectedOption(data);
  }

  render() {
    let options = this.buildOptions();

    return (
      <div className="Select">
        <select className="Select__drop-down"
                onChange={this.dispatchSelectedOption.bind(this)}
                ref="select">
          {options}
        </select>

        <ErrorMessage hasError={this.props.hasError} />
      </div>
    );
  }
}

export default Select;
